import FinanceIcon from "@mui/icons-material/AttachMoney";
import PersonalIcon from "@mui/icons-material/Favorite";
import OperationsIcon from "@mui/icons-material/ManageAccounts";
import AddEntryIcon from "@mui/icons-material/PlaylistAdd";
import UnknownIcon from "@mui/icons-material/QuestionMark";
import MarketingIcon from "@mui/icons-material/Store";
import LeadershipIcon from "@mui/icons-material/SupervisorAccount";
import { alpha, darken, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import OmniAvatar from "../ui/omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const EmpireKPIListItem = props => {
  const { kpiODM, onClickHandler = null, onAddEntryHandler } = props;
  const theme = useTheme();

  const getBusinessPillarColor = businessPillarEnum => {
    switch (businessPillarEnum) {
      case constants.empirePillarEnumes.leadership:
        return theme.palette.highlight.main;
      case constants.empirePillarEnumes.opertations:
        return theme.palette.error.main;
      case constants.empirePillarEnumes.marketing:
        return theme.palette.warning.main;
      case constants.empirePillarEnumes.finance:
        return theme.palette.success.main;
      case constants.empirePillarEnumes.personnel:
        return theme.palette.info.main;
      default:
        return theme.palette.primary.main;
    }
  };

  const getKPIDescription = kpiODM => {
    let theReturn = `${kpiODM.omniData.values.length} Week${
      kpiODM.omniData.values.length === 1 ? "" : "s"
    } of Tracking`;

    return theReturn;
  };

  const getKPIIcon = businessPillarEnum => {
    switch (businessPillarEnum) {
      case constants.empirePillarEnumes.leadership:
        return <LeadershipIcon sx={{ height: 24, width: 24 }} />;
      case constants.empirePillarEnumes.opertations:
        return <OperationsIcon sx={{ height: 24, width: 24 }} />;
      case constants.empirePillarEnumes.marketing:
        return <MarketingIcon sx={{ height: 24, width: 24 }} />;
      case constants.empirePillarEnumes.finance:
        return <FinanceIcon sx={{ height: 24, width: 24 }} />;
      case constants.empirePillarEnumes.personnel:
        return <PersonalIcon sx={{ height: 24, width: 24 }} />;
      default:
        return <UnknownIcon sx={{ height: 24, width: 24 }} />;
    }
  };

  return (
    <ListItem
      disableGutters={true}
      sx={[
        {
          padding: theme.spacing(1),
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: theme.spacing(1),
          borderRadius: theme.spacing(1),
          color: theme.palette.info.contrastText,
          cursor: "pointer",
          boxShadow: theme.shadows[3],
          userSelect: "none",
          webkitUserSelect: "none",
          backgroundColor: alpha(getBusinessPillarColor(kpiODM.omniData.businessPillar), 0.75),
        },
      ]}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler(kpiODM);
        }
      }}
    >
      <Tooltip title={"No Notes"} placement="right">
        <>
          <OmniAvatar
            sx={[
              {
                width: 36,
                height: 36,
                fontSize: "1.2rem",
                border: `2px solid ${theme.palette.info.contrastText}`,
                backgroundColor: getBusinessPillarColor(kpiODM.omniData.businessPillar),
              },
            ]}
          >
            {getKPIIcon(kpiODM.omniData.businessPillar)}
          </OmniAvatar>
        </>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {`${kpiODM.omniData.name}`}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {getKPIDescription(kpiODM)}
          </Typography>
        }
      />
      <OmniListItemButton
        title={"Add Entry"}
        sx={[
          {
            marginTop: "1px",
            marginRight: "1px",
            fill: alpha(theme.palette.info.contrastText, 0.55),
            "& .MuiSvgIcon-root": {
              fill: theme.palette.info.contrastText,
            },
            "&:hover, :active": {
              transform: "scale(1.095)",
              backgroundColor: darken(getBusinessPillarColor(kpiODM.omniData.businessPillar), 0.05),
              "& .MuiSvgIcon-root": {
                fill: theme.palette.secondary.main,
              },
            },
          },
        ]}
        size="large"
        onClick={e => {
          e.stopPropagation();
          onAddEntryHandler(kpiODM);
        }}
        icon={<AddEntryIcon />}
      />
    </ListItem>
  );
};

export default EmpireKPIListItem;
